import React from 'react';
import { Link } from 'react-router-dom';
import logoLight from '../assets/images/etenant-logo-light.png';
import GooglePlayLogo, { PLAY_STORE_URL } from './GooglePlayLogo';

const Footer: React.FC = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer-v2">
      <span className="footer-v2-glow footer-v2-glow-1" aria-hidden="true"></span>
      <span className="footer-v2-glow footer-v2-glow-2" aria-hidden="true"></span>

      <div className="container footer-v2-inner">
        <div className="row g-4 g-lg-5">
          <div className="col-lg-4 col-md-12">
            <Link to="/" className="footer-v2-logo">
              <img src={logoLight} alt="eTENANT" />
            </Link>
            <p className="footer-v2-about">
              The rental manager app for landlords and property owners. Manage properties, tenants, rent, and agreements — all from your phone.
            </p>
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-v2-play"
            >
              <GooglePlayLogo />
              <span>
                <small>Get it on</small>
                Google Play
              </span>
            </a>
          </div>

          <div className="col-lg-2 col-6">
            <h4 className="footer-v2-heading">Product</h4>
            <ul className="footer-v2-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/how-it-works">How It Works</Link></li>
              <li><Link to="/features">Features</Link></li>
            </ul>
          </div>

          <div className="col-lg-2 col-6">
            <h4 className="footer-v2-heading">Support</h4>
            <ul className="footer-v2-links">
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/delete-account">Delete Account</Link></li>
              <li><Link to="/data-deletion">Data Deletion</Link></li>
            </ul>
          </div>

          <div className="col-lg-4 col-12">
            <h4 className="footer-v2-heading">Get in Touch</h4>
            <div className="footer-v2-contact">
              <a href="mailto:support@etenant.net" className="footer-v2-contact-item">
                <span className="footer-v2-contact-icon"><i className="fas fa-envelope" aria-hidden="true"></i></span>
                <span>
                  <small>Email support</small>
                  support@etenant.net
                </span>
              </a>
              <a href="https://www.etenant.net" className="footer-v2-contact-item">
                <span className="footer-v2-contact-icon"><i className="fas fa-globe" aria-hidden="true"></i></span>
                <span>
                  <small>Website</small>
                  www.etenant.net
                </span>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-v2-bottom">
          <p className="mb-0">© {year} eTENANT. All rights reserved.</p>
          <div className="footer-v2-bottom-links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms &amp; Conditions</Link>
          </div>
          <div className="footer-v2-social">
            <a href="https://web.facebook.com/etenant.net" aria-label="eTENANT on Facebook" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook-f" aria-hidden="true"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
